module.exports = __webpack_public_path__ + "img/menuset.aac5d2c7.png";